import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  beneCategories,
  beneWaitingApproved,
} from "../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import arrowDown from "../../../assets/ArrowsIcons/arrow_down_white.svg";
import arrowforward from "../../../assets/ArrowsIcons/arrow_right_white – 1.svg";
import "./index.css";
import allChecker from "../../../assets/Beneficiary Icons/whitecheckmark.png";
import DatePickerComponent from "../../_utils/Calendar";
import { checkUsertoken } from "../../../redux/features/login/login";
import { toast } from "react-toastify";
import { toast_position } from "../../../redux/features/Settings/Authorization";
import { formatAccountNumber } from "../../_utils/FormatAccountNumber";
import clear_filter from "../../../assets/ViewAllTransactions/Clear filter.png";

function InternalTxnFilterSidebar({
  setClearAllFilters,
  popup,
  txnHistorytype,
  isOpen,
  onClose,
  sendCategory,
  setPage,
  setIsSidebarOpen,
  sendDateRange,
  initCategory,
  setInitCategory,
  sendPaymentMethod,
  setStartDateFilter,
  setEndDateFilter,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  setPaymentMethod,
  paymentMethod,
  setSelectedBeneAccId,
  beneAccountId,
  setBeneAccountId,
  accountName,
  setAccountName,
  showDatePicker,
  setShowDatePicker,
  setIsFilterApplied,
  categoryDropdownRef,
  settlementDropdownRef,
  paymentDropdownRef,
  dateRef,
  dropdownOpen,
  setDropdownOpen,
  isDropdownPaymentOpen,
  setDropdownPaymentOpen,
  isDropdownOpen,
  setIsDropdownOpen,
  handleOpenViewModal,
  isViewModalOpen,
  viewModalRef,
  setTxnPayLoad,
  txnPayLoad,
  handleOpenViewModalOwner,
  selectedOwnerAccId,
  setSelectedOwnerAccId,
  accountNumber,
  setAccountNumber,
  txnAmountFilter,
  setTxnAmountFilter,
  startDateFilter,
  endDateFilter,
  setTempEndDate,
  setTempStartDate,
  handleFilterDateRange,
  tempEndDate,
  tempStartDate,
  currentStatus,
  setCurrentStatus,
  isPaymentMethod,
  currentCategory,
  selectedBeneAccId,
  balanceType,
  filterRef,
  internalAccount,
  confidentialDropdownRef,
  isDropdownConfidentialOpen,
  setIsDropdownConfidentialOpen,
  isConfidentialMethod,
  setIsConfidentialMethod,
  confidentialMethod,
  setConfidentialMethod,
  sendConfidentialMethod,
  detailConfidential,
  isConfidentialFilter,
  DashBoardStatus,
  DashBoardisConfidentialFilter,
  SetDashBoardisConfidentialFilter,
  isDashboradCheck,
}) {
  const [settlementSearch, setSettlementSearch] = useState("");
  const [categorySearch, setCategorySearch] = useState("");
  const [sideDrawer, setSideDrawer] = useState(true);
  const [BeneTxnSideDrawerLoader, SetbeneTxnSideDrawerLoder] = useState(false);
  const [DrawerData, setDrawerData] = useState({});
  const [showDeclinedPopup, setshowDeclinedPopup] = useState(false);
  const [deniedTxnId, SetdeniedTxnId] = useState(null);
  const [refreshData, setRefreshData] = useState(false);
  const [AllBeneTxnAccounts, setAllBeneTxnAccounts] = useState([]);
  const [refreshId, SetrefreshId] = useState("");
  const [scrollAmount, setScrollAmount] = useState(0);
  const [isDateConfirmed, setIsDateConfirmed] = useState(false);

  const [activeSection, setActiveSection] = useState(null);
  const isConfPopup = popup === "Confidential transaction";
  const services = useSelector((state) => state.refreshToken.services);
  const hasConfidential = services?.includes("VConfidentialTxn");

  const onChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const categories = useSelector(
    (state) => state?.beneAllVerification.beneTransCategories?.categories
  );

  const dispatch = useDispatch();

  // const settlementDropdownRef = useRef(null);
  const searchInputRef = useRef(null);
  const searchRef = useRef(null);
  const yearDropdownRef = useRef(null);
  const applyBtnRef = useRef(null);

  useEffect(() => {
    dispatch(checkUsertoken());
    dispatch(beneCategories());
  }, [dispatch]);

  const handleClick = (name) => {
    setInitCategory(name);
    setPage(1);
  };
  const handleSettlementClick = (settlement) => {
    setPaymentMethod(settlement);
    setPage(1);
  };

  const handleConfidentialClick = (confidential) => {
    setConfidentialMethod(confidential);
    setPage(1);
  };
  const {
    viewAccountDetailData,
    viewAccountDetailLoading,
    achivedDataDetail,
    unachivedLoadingDetail,
    achivedLoadingDetail,
    unachivedDataDetail,
  } = useSelector((state) => state.verify);
  const { beneTxnAccountLoading, beneTxnAccountData } = useSelector(
    (state) => state?.beneTxnViewAccData
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dateRef.current && !dateRef.current.contains(event.target)) {
        setShowDatePicker(false);
      }
      if (
        categoryDropdownRef.current &&
        !categoryDropdownRef.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }
      if (
        settlementDropdownRef.current &&
        !settlementDropdownRef.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
      }
      if (
        paymentDropdownRef.current &&
        !paymentDropdownRef.current.contains(event.target)
      ) {
        setDropdownPaymentOpen(false);
      }
      if (
        confidentialDropdownRef.current &&
        !confidentialDropdownRef.current.contains(event.target)
      ) {
        setIsDropdownConfidentialOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [
    categoryDropdownRef,
    settlementDropdownRef,
    dateRef,
    paymentDropdownRef,
    confidentialDropdownRef,
  ]);

  useEffect(() => {
    if (viewAccountDetailData) {
      setDrawerData(viewAccountDetailData?.internal_accounts?.[0]);
    }
  }, [viewAccountDetailData]);
  const handleScroll = (scrollAmount) => {
    window.scrollBy({
      top: scrollAmount,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    const handleKeyDown = (e) => {
      switch (e.keyCode) {
        case 13: // enter key
          isOpen && applyBtnRef.current.click();
          break;
        case 83: // s key
          setScrollAmount(30);
          break;
        case 87: // w key
          setScrollAmount(-30);
          break;
        default:
          break;
      }
    };

    const handleKeyUp = () => {
      setScrollAmount(0);
    };

    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("keyup", handleKeyUp);

    const scrollInterval = setInterval(() => {
      if (scrollAmount !== 0) {
        handleScroll(scrollAmount);
      }
    }, 10);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("keyup", handleKeyUp);
      clearInterval(scrollInterval);
    };
  }, [scrollAmount, isOpen]);
  const handleConfirm = () => {
    setShowDatePicker(false);
    setIsDateConfirmed(true);
  };

  useEffect(() => {
    setClearAllFilters(() => clearFilter); // Pass function to parent
  }, [setClearAllFilters]);

  const handleCancel = () => {
    setShowDatePicker(false);
    setIsDateConfirmed(false);
    setStartDate(null);
    setEndDate(null);
  };
  const clearFilter = () => {
    setInitCategory("");
    // setIsPaymentMethod("");
    setPaymentMethod("");
    setIsDropdownOpen(false);
    setCategorySearch("");
    setSettlementSearch("");
    // setIsSidebarOpen(false);
    setShowDatePicker(false);
    setStartDate(null);
    setEndDate(null);
    setTempEndDate("");
    setTempStartDate("");
    sendPaymentMethod("");
    sendCategory("");
    setStartDateFilter("");
    setEndDateFilter("");
    setTxnAmountFilter("");
    setAccountName("");
    !isConfPopup && setConfidentialMethod("");
    !isConfPopup && sendConfidentialMethod("");

    setIsFilterApplied(
      txnHistorytype === "internalTxnHistory" ||
        txnHistorytype === "ownerDetailTxnHistory"
        ? true
        : false
    );
    if (
      txnHistorytype !== "internalTxnHistory" &&
      txnHistorytype !== "ownerDetailTxnHistory"
    ) {
      setSelectedOwnerAccId("");
      setAccountNumber("");
      sendConfidentialMethod("");
    } else if (
      txnHistorytype === "ownerDetailTxnHistory" &&
      balanceType == "credit"
    ) {
      setSelectedOwnerAccId("");
    }

    if (
      txnHistorytype !== "ownerDetailTxnHistory" &&
      balanceType !== "credit"
    ) {
      setBeneAccountId("");
      setSelectedBeneAccId("");
      setAccountNumber("");
    }
    setTxnPayLoad({
      txnPayLoad,
      amount: "",
      ownerAccountName: "",
      ownerAccountId: "",
      ownerbankAccountIFSC: "",
      ownerbankAccountNo: "",
    });
  };
  const convertDate = (dateString) => {
    const date = new Date(dateString);
    const timestamp = Math.floor(date.getTime() / 1000);

    return timestamp;
  };
  const filterCategory = () => {
    // setTxnPayLoad({ ...txnPayLoad });
    if (
      txnHistorytype !== "internalTxnHistory" &&
      txnHistorytype !== "ownerDetailTxnHistory"
    ) {
      setSelectedOwnerAccId(txnPayLoad?.ownerAccountId);
      setAccountNumber(txnPayLoad?.ownerbankAccountNo);
    } else if (
      txnHistorytype === "ownerDetailTxnHistory" &&
      balanceType === "credit"
    ) {
      setSelectedOwnerAccId(txnPayLoad?.ownerAccountId);
    }
    setTxnAmountFilter(txnPayLoad?.amount);
    setPage(1);
    handleFilterDateRange(convertDate(startDate), convertDate(endDate));
    setTempStartDate(startDateFilter);
    sendConfidentialMethod(confidentialMethod);
    setTempEndDate(endDateFilter);
    sendPaymentMethod(paymentMethod);
    if (txnHistorytype !== "ownerDetailTxnHistory" && balanceType !== "debit") {
      setSelectedBeneAccId(beneAccountId);
    }
    // setTxnAmount(txnAmount);
    setShowDatePicker(false);
    setIsSidebarOpen(false);
    if (
      DashBoardisConfidentialFilter === "Show only confidential" &&
      isDashboradCheck
    ) {
      sendConfidentialMethod(isConfidentialFilter);
    } else {
      sendConfidentialMethod(confidentialMethod);
    }
  };

  const handleTxnSearch = (text) => {
    const sanitizedText = text
      .replace(/[^0-9.]/g, "")
      .replace(/(\..*)\./g, "$1");

    if (sanitizedText === "") {
      if (txnAmountFilter.length === 0) {
        setTxnAmountFilter("");
      }
      setTxnPayLoad({
        ...txnPayLoad,
        amount: "",
      });
      return;
    }

    const amount = parseFloat(sanitizedText);
    if (!isNaN(amount)) {
      setTxnPayLoad({
        ...txnPayLoad,
        amount: sanitizedText,
      });
    }
  };

  const filteredSettlements = ["All", "NEFT", "RTGS"].filter((settlement) =>
    settlement.toLowerCase().includes(settlementSearch.toLowerCase())
  );
  const filterConfidential = ["Show only confidential", "Hide confidential"];
  const handleCategorySearchChange = (event) => {
    setCategorySearch(event.target.value);
  };

  const filteredCategories = categories.filter((category) =>
    category.name.toLowerCase().includes(categorySearch.toLowerCase())
  );
  const additional_Data = beneTxnAccountData?.transaction?.[0]?.additional_data;

  const handleApproval = async (id) => {
    SetbeneTxnSideDrawerLoder(true);
    dispatch(checkUsertoken());
    const data = await dispatch(beneWaitingApproved(id));

    if (data) {
      const updatedData = viewAccountDetailData?.internal_accounts?.map(
        (item) => {
          if (item.id === id) {
            return {
              ...item,
              approval_status:
                // item.approval_status === "approved" ? "pending" : "approved",
                item.approval_status === "pending" ? "approved" : "pending",
              status: data?.payload.status,
            };
          }
          return item;
        }
      );
      setDrawerData(updatedData?.[0]);
    }

    setTimeout(() => {
      SetbeneTxnSideDrawerLoder(false);
      setRefreshData(true);
    }, 2000);

    setTimeout(() => {
      if (data.payload.status === true) {
        window.location.reload();
      }
    }, 2000);
  };

  useEffect(() => {
    setRefreshData(false);
  }, [refreshData, dispatch]);

  useEffect(() => {
    if (isConfidentialFilter && DashBoardStatus === "confidential") {
      handleConfidentialClick(isConfidentialFilter);
      filterCategory();
    }
  }, []);
  const handleDeclinedTxn = (id) => {
    setshowDeclinedPopup(true);
    SetdeniedTxnId(id);
  };
  const handleClosePopup = () => {
    setshowDeclinedPopup(false);
  };

  const handleSettlementSearchChange = (event) => {
    setSettlementSearch(event.target.value);
  };

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    onClose(open);
  };

  const formatDate = (date) => {
    return `${date.getDate()} ${date.toLocaleString("default", {
      month: "short",
    })}, ${date.getFullYear()}`;
  };
  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    setIsDateConfirmed(false);
  };

  const handleFilterApply = () => {
    if (
      ((txnHistorytype === "internalTxnHistory" ||
        txnHistorytype === "ownerDetailTxnHistory") &&
        selectedOwnerAccId?.length > 0 &&
        accountNumber &&
        (paymentMethod ||
          confidentialMethod ||
          txnPayLoad?.amount.length > 0 ||
          txnAmountFilter.length > 0 ||
          txnPayLoad?.ownerAccountId ||
          isConfidentialMethod?.length > 0 ||
          isPaymentMethod?.length > 0)) ||
      (startDate && endDate && isDateConfirmed)
    ) {
      return true;
    }

    if (
      (paymentMethod ||
        txnPayLoad?.amount.length > 0 ||
        txnAmountFilter.length > 0 ||
        txnPayLoad?.ownerAccountId ||
        isPaymentMethod?.length > 0 ||
        selectedOwnerAccId?.length > 0) &&
      startDate &&
      endDate &&
      isDateConfirmed
    ) {
      return true;
    }

    if (txnPayLoad?.amount.length > 0 && !startDate && !endDate) {
      return true;
    }
    if (txnAmountFilter.length > 0 && !startDate && !endDate) {
      return true;
    }
    if (txnPayLoad?.ownerAccountId && !startDate && !endDate) {
      return true;
    }

    if (paymentMethod && !startDate && !endDate) {
      return true;
    }
    if (confidentialMethod && !startDate && !endDate) {
      return true;
    }
    if (isConfidentialMethod?.length > 0 && !startDate && !endDate) {
      return true;
    }
    if (isPaymentMethod?.length > 0 && !startDate && !endDate) {
      return true;
    }
    if (selectedOwnerAccId?.length > 0 && !startDate && !endDate) {
      return true;
    }

    if (startDateFilter && endDateFilter) {
      return true;
    }

    if (startDate && endDate && isDateConfirmed) {
      return true;
    }

    return false;
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 800);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 800);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);

  return (
    <>
      {isMobile ? (
        <>
          <div
            // onClose={toggleSidebar(false)}
            className={`internalTxnviewallsidebar ${
              isOpen ? "open" : "closed"
            }`}
            style={{
              backgroundColor: "var(--Blue_3)",
              pointerEvents: isViewModalOpen ? "none" : "",
              position:
                txnHistorytype === "internalTxnHistory" ? "absolute" : "fixed",
              marginTop:
                txnHistorytype === "internalTxnHistory"
                  ? "60px"
                  : txnHistorytype === "ownerDetailTxnHistory" &&
                    !internalAccount
                  ? "72px"
                  : "72px",
            }}
          >
            <div
              style={{
                height: "100vh",
                overflow: "hidden",
                backgroundColor: "var(--Blue_3)",
              }}
            >
              <div
                className="flex gap-3 internalTxnviewallFilterDiv px-5"
                style={{
                  visibility: isOpen ? "visible" : "hidden",
                  transition: `opacity 0.2s ease-in ${isOpen ? "0s" : "0.2s"}`,
                  opacity: isOpen ? "1" : "0",
                  borderTop: "2px solid rgb(29, 58, 109)",
                  flexDirection: "column",
                  justifyContent: "unset",
                  height:
                    txnHistorytype === "ownerDetailTxnHistory"
                      ? "84vh"
                      : "84vh",
                  // height: "72vh",
                  overflowY: "auto",
                  paddingBottom: "30px",
                }}
              >
                {!isDropdownOpen && (
                  <div
                    className="relative w-[100%] "
                    style={{ height: "64px" }}
                  >
                    <span
                      style={{
                        color: "var(--Primary_grey)",
                        width: "35px",
                        height: "19px",
                        font: "normal normal 12px/19px Open Sans",
                      }}
                    >
                      Payment method
                    </span>

                    <div
                      className="internalTxn_payment_select mt-[10px]"
                      ref={paymentDropdownRef}
                      onClick={(e) => {
                        setDropdownPaymentOpen(!isDropdownPaymentOpen);
                        setIsDropdownOpen(false);
                        setShowDatePicker(false);
                        e.stopPropagation();
                      }}
                      style={{
                        height: isDropdownPaymentOpen ? "125px" : "35px",
                        outline: isDropdownPaymentOpen
                          ? "1px solid var(--Failed)"
                          : "",
                        transition: isDropdownPaymentOpen ? "none" : "",
                        opacity:
                          currentStatus === "require approval" ? "0.5" : "1",
                        width: "100%",
                        zIndex: "9999999",
                      }}
                      disabled={
                        currentStatus === "require approval" ? true : false
                      }
                    >
                      <div className="bene_txn_category_select_select">
                        <div
                          className="paymentTxn_category_select_scroll_line"
                          style={{
                            display: isDropdownPaymentOpen ? "block" : "none",
                            width: "calc(-24px + 100%)",
                          }}
                        ></div>

                        <span
                          style={{
                            fontSize: "12px",
                            paddingLeft: isDropdownPaymentOpen && "9px",
                            color: paymentMethod ? "" : "var(--Primary_grey)",
                          }}
                        >
                          {paymentMethod === "" ? "Select type" : paymentMethod}
                        </span>
                        <div className="flex flex-row items-center">
                          <img
                            src={clear_filter}
                            alt="clear"
                            className="w-[9px] h-[9px]"
                            style={{
                              visibility:
                                paymentMethod === "" || !isOpen
                                  ? "hidden"
                                  : "visible",
                            }}
                            onClick={(e) => {
                              setPaymentMethod("");
                              e.stopPropagation();
                            }}
                          />
                          <div
                            className="w-[1px] h-[16px] mx-[8px]"
                            style={{
                              backgroundColor: "var(--Blue_3)",
                              visibility:
                                paymentMethod === "" || !isOpen
                                  ? "hidden"
                                  : "visible",
                            }}
                          ></div>
                          <img
                            src={arrowDown}
                            alt="down"
                            className="w-[11px] h-[11px]"
                            style={{
                              transform: isDropdownPaymentOpen
                                ? "rotate(180deg)"
                                : "rotate(0deg)",
                            }}
                          />
                        </div>
                      </div>

                      {isDropdownPaymentOpen && (
                        <div className="bg-Blue_8 absolute top-12 flex flex-col items-start rounded-[10px] w-full h-[82px] px-1">
                          {["NEFT", "RTGS"].map((settlement) => (
                            <div
                              key={settlement}
                              className="flex w-full h-[35px] hover:bg-Blue_7 cursor-pointer rounded-[5px] border-l-transparent"
                              style={{
                                backgroundColor:
                                  paymentMethod === settlement && paymentMethod
                                    ? "var(--Blue_6)"
                                    : "",
                                padding: "0px 8px",
                              }}
                              onClick={(e) => {
                                handleSettlementClick(settlement);
                                setIsDropdownOpen(false);
                              }}
                            >
                              <span className="pl-2 py-2.5 text-Primary_grey text-xs truncate w-[90%] ">
                                {settlement}
                              </span>
                              <div
                                style={{
                                  display:
                                    paymentMethod == settlement
                                      ? "flex"
                                      : "none",
                                  textAlign: "right",
                                  justifyContent: "end",
                                  paddingRight: "1px",
                                  marginTop: "10px",
                                }}
                              >
                                <img
                                  style={{
                                    height: "13px",
                                    width: "14px",
                                  }}
                                  src={allChecker}
                                  alt="check"
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {hasConfidential && !isDropdownOpen && (
                  <div
                    className="relative w-[100%] "
                    style={{ height: "64px" }}
                  >
                    <span
                      style={{
                        color: "var(--Primary_grey)",
                        width: "35px",
                        height: "19px",
                        font: "normal normal 12px/19px Open Sans",
                      }}
                    >
                      Show/hide confidential transactions
                    </span>

                    <div
                      className="bene_txn_payment_select mt-[10px]"
                      ref={confidentialDropdownRef}
                      onClick={(e) => {
                        setIsDropdownConfidentialOpen(
                          !isDropdownConfidentialOpen
                        );
                        setDropdownOpen(false);
                        setShowDatePicker(false);
                        e.stopPropagation();
                      }}
                      style={{
                        width: "100%",
                        height: isDropdownConfidentialOpen ? "125px" : "35px",
                        outline: isDropdownConfidentialOpen
                          ? "1px solid var(--Failed)"
                          : "",
                        transition: isDropdownConfidentialOpen ? "none" : "",
                        opacity:
                          currentStatus === "require approval" ||
                          (txnHistorytype === "internalTxnHistory" &&
                            detailConfidential === "Y")
                            ? "0.5"
                            : "1",
                        zIndex: "999999",
                      }}
                      disabled={
                        currentStatus === "require approval" ||
                        (txnHistorytype === "internalTxnHistory" &&
                          detailConfidential === "Y")
                          ? true
                          : false
                      }
                    >
                      <div className="bene_txn_category_select_select">
                        <div
                          className="txn_category_select_scroll_line"
                          style={{
                            display: isDropdownConfidentialOpen
                              ? "block"
                              : "none",
                            width: "calc(-24px + 100%)",
                          }}
                        ></div>

                        <span
                          style={{
                            fontSize: "12px",
                            paddingLeft: isDropdownConfidentialOpen && "9px",
                            color: confidentialMethod
                              ? "var(--Primary_white)"
                              : "var(--Primary_grey)",
                          }}
                        >
                          {confidentialMethod === ""
                            ? "Default (all transactions)"
                            : confidentialMethod}
                        </span>
                        <div className="flex flex-row items-center">
                          <img
                            src={clear_filter}
                            alt="clear"
                            className="w-[9px] h-[9px]"
                            style={{
                              visibility:
                                confidentialMethod === "" || !isOpen
                                  ? "hidden"
                                  : "visible",
                            }}
                            onClick={(e) => {
                              setConfidentialMethod("");
                              e.stopPropagation();
                            }}
                          />
                          <div
                            className="w-[1px] h-[16px] mx-[8px]"
                            style={{
                              backgroundColor: "var(--Blue_3)",
                              visibility:
                                confidentialMethod === "" || !isOpen
                                  ? "hidden"
                                  : "visible",
                            }}
                          ></div>
                          <img
                            src={arrowDown}
                            alt="down"
                            className="w-[11px] h-[11px]"
                            style={{
                              transform: isDropdownConfidentialOpen
                                ? "rotate(180deg)"
                                : "rotate(0deg)",
                            }}
                          />
                        </div>
                      </div>

                      {isDropdownConfidentialOpen && (
                        <div className="bg-Blue_8 absolute top-12 flex flex-col items-start rounded-[10px] w-full h-[82px] px-1">
                          {filterConfidential.map((confidential) => (
                            <div
                              key={confidential}
                              className="flex w-full h-[35px] hover:bg-Blue_7 cursor-pointer rounded-[5px] border-l-transparent"
                              style={{
                                backgroundColor:
                                  confidentialMethod === confidential &&
                                  confidentialMethod
                                    ? "var(--Blue_6)"
                                    : "",
                                padding: "0px 5px",
                              }}
                              onClick={() => {
                                handleConfidentialClick(confidential);
                                SetDashBoardisConfidentialFilter(confidential);
                                setIsDropdownConfidentialOpen(false);
                              }}
                            >
                              <span className="pl-2 py-2.5 text-Primary_grey text-xs truncate w-[90%] ">
                                {confidential}
                              </span>
                              <div
                                style={{
                                  display:
                                    confidentialMethod == confidential
                                      ? "flex"
                                      : "none",
                                  textAlign: "right",
                                  justifyContent: "end",
                                  paddingRight: "1px",
                                  marginTop: "10px",
                                }}
                              >
                                <img
                                  style={{
                                    height: "13px",
                                    width: "14px",
                                  }}
                                  src={allChecker}
                                  alt="check"
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                )}

                <div className="relative w-[100%]" style={{ height: "64px" }}>
                  <span
                    style={{
                      color: "var(--Primary_grey)",
                      width: "35px",
                      height: "19px",
                      font: "normal normal 12px/19px Open Sans",
                    }}
                  >
                    Destination account
                  </span>
                  <div
                    ref={viewModalRef}
                    className="relative flex flex-col items-center rounded-[10px] h-[35px] pl-[12px] pr-[7px] py-2.5 bg-Blue_8 w-[100%] mt-[5px]"
                    style={{
                      opacity:
                        txnHistorytype === "ownerDetailTxnHistory" &&
                        balanceType === "credit"
                          ? "0.5"
                          : currentStatus === "require approval"
                          ? "0.5"
                          : "0.5",
                      cursor:
                        txnHistorytype === "ownerDetailTxnHistory" &&
                        balanceType === "credit"
                          ? "default"
                          : currentStatus === "require approval"
                          ? "default"
                          : "default",
                    }}
                  >
                    <button
                      className="flex items-center justify-between border-transparent active:border-white w-full mt-[-1px]"
                      // onClick={handleOpenViewModalOwner}
                      onClick={() => {
                        if (
                          txnHistorytype === "ownerDetailTxnHistory" &&
                          balanceType === "credit"
                        ) {
                          return;
                        } else {
                          toast.info("Coming Soon...", toast_position);
                        }
                      }}
                      disabled={
                        currentStatus === "require approval" ? true : false
                      }
                      style={{
                        cursor:
                          txnHistorytype === "ownerDetailTxnHistory" &&
                          balanceType === "credit"
                            ? "default"
                            : currentStatus === "require approval"
                            ? "default"
                            : "default",
                      }}
                    >
                      <span
                        className="internalTxn_filter_acc_selected text-xs truncate"
                        style={{
                          color: txnPayLoad?.ownerbankAccountNo
                            ? "var(--Primary_white)"
                            : "var(--Primary_grey)",
                        }}
                      >
                        {txnHistorytype === "ownerDetailTxnHistory" &&
                        balanceType === "credit" &&
                        accountNumber
                          ? formatAccountNumber(accountNumber)
                          : "Select owner account"}
                        {/* {txnPayLoad?.ownerbankAccountNo === ""
                      ? "Select owner account"
                      : txnPayLoad?.ownerbankAccountNo} */}
                      </span>
                      <img
                        className="internalTxn_viewall_select_account h-[11px] w-[11px]"
                        src={arrowDown}
                        alt=""
                      />
                    </button>
                  </div>
                </div>

                <div className="relative w-[100%]" style={{ height: "64px" }}>
                  <span
                    style={{
                      color: "var(--Primary_grey)",
                      width: "35px",
                      height: "19px",
                      font: "normal normal 12px/19px Open Sans",
                    }}
                  >
                    Source account
                  </span>
                  <div
                    className="relative flex flex-col items-center rounded-[10px] h-[35px] pl-[12px] pr-[7px] py-2.5 bg-Blue_8 w-[100%px] mt-[5px]"
                    style={{
                      opacity:
                        txnHistorytype !== "internalTxnHistory" &&
                        txnHistorytype !== "ownerDetailTxnHistory"
                          ? "1"
                          : txnHistorytype === "ownerDetailTxnHistory" &&
                            balanceType === "credit"
                          ? "1"
                          : currentStatus === "require approval"
                          ? "0.5"
                          : "0.5",
                    }}
                  >
                    <button
                      className="flex items-center justify-between border-transparent active:border-white w-full mt-[-1px]"
                      onClick={(e) => {
                        if (
                          txnHistorytype !== "internalTxnHistory" &&
                          txnHistorytype !== "ownerDetailTxnHistory"
                        ) {
                          handleOpenViewModalOwner();
                          e.stopPropagation();
                        } else if (
                          txnHistorytype === "ownerDetailTxnHistory" &&
                          balanceType === "credit"
                        ) {
                          handleOpenViewModalOwner();
                          e.stopPropagation();
                        }
                      }}
                      disabled={
                        currentStatus === "require approval" ||
                        txnHistorytype === "internalTxnHistory" ||
                        (txnHistorytype === "ownerDetailTxnHistory" &&
                          balanceType === "debit")
                          ? true
                          : false
                      }
                      style={{
                        cursor:
                          txnHistorytype === "internalTxnHistory" ||
                          (txnHistorytype === "ownerDetailTxnHistory" &&
                            balanceType === "debit")
                            ? "default"
                            : "pointer",
                      }}
                    >
                      <span
                        className="internalTxn_filter_acc_selected text-xs truncate"
                        style={{
                          color: txnPayLoad?.ownerbankAccountNo
                            ? "var(--Primary_white)"
                            : "var(--Primary_grey)",
                        }}
                      >
                        {txnHistorytype === "internalTxnHistory" &&
                        accountNumber
                          ? formatAccountNumber(accountNumber)
                          : txnHistorytype === "ownerDetailTxnHistory" &&
                            balanceType === "debit" &&
                            accountNumber
                          ? formatAccountNumber(accountNumber)
                          : txnPayLoad?.ownerbankAccountNo === ""
                          ? "Select owner account"
                          : formatAccountNumber(txnPayLoad?.ownerbankAccountNo)}
                      </span>
                      <div className="flex flex-row items-center">
                        <img
                          src={clear_filter}
                          alt="clear"
                          className="w-[9px] h-[9px]"
                          style={{
                            visibility:
                              (txnPayLoad?.ownerbankAccountNo === "" &&
                                txnPayLoad?.ownerAccountId === "") ||
                              !isOpen
                                ? "hidden"
                                : "visible",
                          }}
                          onClick={(e) => {
                            setTxnPayLoad({
                              ...txnPayLoad,
                              ownerbankAccountNo: "",
                              ownerAccountId: "",
                            });
                            e.stopPropagation();
                          }}
                        />
                        <div
                          className="w-[1px] h-[16px] mx-[8px]"
                          style={{
                            backgroundColor: "var(--Blue_3)",
                            visibility:
                              (txnPayLoad?.ownerbankAccountNo === "" &&
                                txnPayLoad?.ownerAccountId === "") ||
                              !isOpen
                                ? "hidden"
                                : "visible",
                          }}
                        ></div>
                        <img
                          className="txn_viewall_select_account h-[11px] w-[11px]"
                          src={arrowDown}
                          alt=""
                        />
                      </div>
                    </button>
                  </div>

                  {/* <div className="relative w-[200px] mt-5">
              <span
                style={{
                  color: "var(--Primary_grey)",
                  width: "35px",
                  height: "19px",
                  font: "normal normal 12px/19px Open Sans",
                }}
              >
                IFSC code
              </span>
              <input
                className="w-[216px] h-[35px] px-4 py-2.5 rounded-[10px] bg-Blue_8 text-Primary_white placeholder-Primary_grey text-xs mt-[5px]"
                maxlength="11"
                type="text"
                name="ifscnumber"
                placeholder="Enter IFSC code"
                value=""
                // onChange={(e) => handleTxnSearch(e.target.value)}
              />
            </div>
            <div>
              <p class="internalTxn_number_text">
                Note : Account number and IFSC code <br />
                must be filled to filter by bank details
              </p>
            </div> */}
                </div>

                <div
                  className={`relative w-[100%]`}
                  style={{
                    height: "64px",
                  }}
                >
                  <span
                    style={{
                      color: "var(--Primary_grey)",
                      width: "35px",
                      height: "19px",
                      font: "normal normal 12px/19px Open Sans",
                    }}
                  >
                    Amount
                  </span>

                  <div
                    className="w-[100%] h-[35px] px-4 py-2.5 rounded-[10px] bg-Blue_8 text-Primary_white placeholder-Primary_grey text-xs mt-[5px]"
                    style={{
                      opacity:
                        currentStatus === "require approval" ? "0.3" : "1",
                      outline: "none",
                    }}
                  >
                    &#8377;
                    <input
                      className="ml-[3px] bg-Blue_8 text-Primary_white placeholder-Primary_grey"
                      type="text"
                      placeholder="Enter transaction amount"
                      value={
                        txnPayLoad?.amount.length > 0 ? txnPayLoad?.amount : ""
                      }
                      name="txnamount"
                      onChange={(e) => handleTxnSearch(e.target.value)}
                      onFocus={() => setActiveSection("txnamount")}
                      disabled={
                        currentStatus === "require approval" ? true : false
                      }
                    />
                  </div>
                </div>
                <div>
                  <span
                    style={{
                      color: "var(--Primary_grey)",
                      width: "62px",
                      height: "17px",
                      font: "normal normal 12px/19px Open Sans",
                      marginBottom: "5px",
                    }}
                  >
                    Date range
                  </span>
                  <div
                    className="internalTxn_Calendar_main_div flex flex-col items-center bg-Blue_8 top-[86px]"
                    // style={{ opacity: dropdownOpen ? 0 : 1 }}
                    ref={dateRef}
                    style={{
                      width: "100%",
                      height: showDatePicker ? "" : "35px",
                      border: showDatePicker
                        ? "1px solid var(--Failed)"
                        : "none",
                      // borderRadius: showDatePicker ? "10px" : "auto",
                    }}
                  >
                    <div
                      className="flex flex-row items-center justify-between rounded-[10px] bg-Blue_8"
                      style={{
                        width: "100%",
                        height: showDatePicker ? "" : "35px",
                        // border: showDatePicker ? "none" : "1px solid var(--Failed)",
                        opacity:
                          currentStatus === "require approval" ? "0.5" : "1",
                        cursor:
                          currentStatus === "require approval"
                            ? "default"
                            : "pointer",
                      }}
                      onClick={(e) => {
                        setShowDatePicker(!showDatePicker);
                        setDropdownOpen(false);
                        setIsDropdownOpen(false);
                        setActiveSection("date");
                      }}
                      disabled={
                        currentStatus === "require approval" ? true : false
                      }
                      // style={{ opacity: dropdownOpen ? 0 : 1 }}
                    >
                      <div
                        className="internalTxn_date_heading_div cursor-pointer"
                        style={{
                          borderTopLeftRadius: showDatePicker ? "7px" : "none",
                          borderLeft: showDatePicker
                            ? "1px solid var(--Failed)"
                            : "none",
                        }}
                        // onClick={() => setShowDatePicker((prev) => !prev)}
                      >
                        <div
                          className="internalTxn_date_heading_left"
                          style={{
                            color: startDate
                              ? "var(--Primary_white)"
                              : "var(--Primary_grey)",
                          }}
                        >
                          {startDate
                            ? formatDate(startDate)
                            : "Select from date"}
                        </div>
                      </div>
                      <img
                        src={arrowforward}
                        className="internalTxn_viewall_calendar_icon"
                      />
                      <div
                        className="internalTxn_date_select_div cursor-pointer"
                        style={{
                          borderTopRightRadius: showDatePicker ? "7px" : "none",
                          borderRight: showDatePicker
                            ? "1px solid var(--Failed)"
                            : "none",
                        }}
                        // onClick={() => setShowDatePicker((prev) => !prev)}
                      >
                        <div
                          className="internalTxn_date_heading_right"
                          style={{
                            color: endDate
                              ? "var(--Primary_white)"
                              : "var(--Primary_grey)",
                          }}
                        >
                          {endDate ? formatDate(endDate) : "Select to date"}
                        </div>
                      </div>
                    </div>
                    {showDatePicker && (
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                      >
                        <DatePickerComponent
                          startDate={startDate}
                          endDate={endDate}
                          handleDateChange={handleDateChange}
                          handleCancel={handleCancel}
                          handleConfirm={handleConfirm}
                          showDatePicker={showDatePicker}
                          yearDropdownRef={yearDropdownRef}
                          dateRef={dateRef}
                          setShowDatePicker={setShowDatePicker}
                          isOpen={isOpen}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div
              className="internalTxnFilterbuttonContainer"
              style={{
                padding: "15px 20px",
                gap: "20px",
                backgroundColor: "var(--Blue_7)",
                borderTopLeftRadius: "22px",
                borderTopRightRadius: "22px",
                bottom: "0",
                position: "fixed",
                width: "100%",
                zIndex: "99999",
                display: "flex",
                alignItems: "center",
              }}
            >
              <div
                className="rounded-[40px] acc-viewall-clear-filter border border-Primary_grey text-Primary_grey text-xs text-center hover:opacity-80 w-1/2 py-[10px]"
                onClick={() => {
                  if (
                    txnHistorytype === "internalTxnHistory" &&
                    accountNumber &&
                    selectedOwnerAccId?.length > 0 &&
                    (paymentMethod ||
                      (!isConfPopup &&
                        (confidentialMethod ||
                          isConfidentialMethod?.length > 0)) ||
                      startDate ||
                      endDate ||
                      txnPayLoad?.amount.length > 0 ||
                      // txnPayLoad?.ownerAccountId ||
                      isPaymentMethod?.length > 0 ||
                      txnAmountFilter?.length > 0 ||
                      (startDateFilter && endDateFilter))
                  ) {
                    clearFilter();
                  } else if (
                    txnHistorytype === "ownerDetailTxnHistory" &&
                    balanceType === "credit"
                  ) {
                    if (
                      txnHistorytype === "ownerDetailTxnHistory" &&
                      balanceType === "credit" &&
                      accountNumber &&
                      selectedBeneAccId?.length > 0 &&
                      (paymentMethod ||
                        (!isConfPopup &&
                          (confidentialMethod ||
                            isConfidentialMethod?.length > 0)) ||
                        txnPayLoad?.amount.length > 0 ||
                        selectedOwnerAccId?.length > 0 ||
                        txnPayLoad?.ownerAccountId ||
                        (startDate && endDate) ||
                        isPaymentMethod?.length > 0 ||
                        txnAmountFilter?.length > 0 ||
                        (startDateFilter && endDateFilter))
                    ) {
                      clearFilter();
                    }
                  } else if (
                    txnHistorytype === "ownerDetailTxnHistory" &&
                    balanceType === "debit"
                  ) {
                    if (
                      txnHistorytype === "ownerDetailTxnHistory" &&
                      balanceType === "debit" &&
                      accountNumber &&
                      selectedOwnerAccId?.length > 0 &&
                      (paymentMethod ||
                        (!isConfPopup &&
                          (confidentialMethod ||
                            isConfidentialMethod?.length > 0)) ||
                        txnPayLoad?.amount.length > 0 ||
                        txnPayLoad?.beneAccountId ||
                        (startDate && endDate) ||
                        isPaymentMethod?.length > 0 ||
                        txnAmountFilter?.length > 0 ||
                        (startDateFilter && endDateFilter))
                    ) {
                      clearFilter();
                    }
                  } else if (
                    (txnHistorytype !== "internalTxnHistory" &&
                      !accountNumber &&
                      paymentMethod) ||
                    startDate ||
                    endDate ||
                    (!isConfPopup &&
                      (confidentialMethod ||
                        isConfidentialMethod?.length > 0)) ||
                    txnPayLoad?.amount.length > 0 ||
                    txnPayLoad?.ownerAccountId ||
                    isPaymentMethod?.length > 0 ||
                    txnAmountFilter?.length > 0 ||
                    selectedOwnerAccId?.length > 0 ||
                    (startDateFilter && endDateFilter)
                  ) {
                    clearFilter();
                  }
                }}
                style={{
                  cursor:
                    txnHistorytype === "internalTxnHistory"
                      ? txnHistorytype === "internalTxnHistory" &&
                        accountNumber &&
                        selectedOwnerAccId?.length > 0 &&
                        (paymentMethod ||
                          (!isConfPopup &&
                            (confidentialMethod ||
                              isConfidentialMethod?.length > 0)) ||
                          txnPayLoad?.amount.length > 0 ||
                          // txnPayLoad?.ownerAccountId ||
                          (startDate && endDate) ||
                          isPaymentMethod?.length > 0 ||
                          txnAmountFilter?.length > 0 ||
                          (startDateFilter && endDateFilter))
                        ? "pointer"
                        : "default"
                      : txnHistorytype === "ownerDetailTxnHistory" &&
                        balanceType == "credit"
                      ? txnHistorytype === "ownerDetailTxnHistory" &&
                        accountNumber &&
                        selectedBeneAccId?.length > 0 &&
                        (paymentMethod ||
                          (!isConfPopup &&
                            (confidentialMethod ||
                              isConfidentialMethod?.length > 0)) ||
                          txnPayLoad?.amount.length > 0 ||
                          txnPayLoad?.ownerAccountId ||
                          (startDate && endDate) ||
                          isPaymentMethod?.length > 0 ||
                          txnAmountFilter?.length > 0 ||
                          selectedOwnerAccId?.length > 0 ||
                          (startDateFilter && endDateFilter))
                        ? "pointer"
                        : "default"
                      : txnHistorytype === "ownerDetailTxnHistory" &&
                        balanceType == "debit"
                      ? txnHistorytype === "ownerDetailTxnHistory" &&
                        accountNumber &&
                        selectedOwnerAccId?.length > 0 &&
                        (paymentMethod ||
                          (!isConfPopup &&
                            (confidentialMethod ||
                              isConfidentialMethod?.length > 0)) ||
                          txnPayLoad?.amount.length > 0 ||
                          txnPayLoad?.beneAccountId ||
                          (startDate && endDate) ||
                          isPaymentMethod?.length > 0 ||
                          txnAmountFilter?.length > 0 ||
                          (startDateFilter && endDateFilter))
                        ? "pointer"
                        : "default"
                      : paymentMethod ||
                        (!isConfPopup &&
                          (confidentialMethod ||
                            isConfidentialMethod?.length > 0)) ||
                        txnPayLoad?.amount.length > 0 ||
                        txnPayLoad?.ownerAccountId ||
                        (startDate && endDate) ||
                        isPaymentMethod?.length > 0 ||
                        txnAmountFilter?.length > 0 ||
                        selectedOwnerAccId?.length > 0 ||
                        (startDateFilter && endDateFilter)
                      ? "pointer"
                      : "default",
                  opacity:
                    txnHistorytype === "internalTxnHistory"
                      ? txnHistorytype === "internalTxnHistory" &&
                        accountNumber &&
                        selectedOwnerAccId?.length > 0 &&
                        (paymentMethod ||
                          (!isConfPopup &&
                            (confidentialMethod ||
                              isConfidentialMethod?.length > 0)) ||
                          txnPayLoad?.amount.length > 0 ||
                          // txnPayLoad?.ownerAccountId ||
                          (startDate && endDate) ||
                          isPaymentMethod?.length > 0 ||
                          txnAmountFilter?.length > 0 ||
                          (startDateFilter && endDateFilter))
                        ? "1"
                        : "0.6"
                      : txnHistorytype === "ownerDetailTxnHistory" &&
                        balanceType == "credit"
                      ? txnHistorytype === "ownerDetailTxnHistory" &&
                        accountNumber &&
                        selectedBeneAccId?.length > 0 &&
                        (paymentMethod ||
                          (!isConfPopup &&
                            (confidentialMethod ||
                              isConfidentialMethod?.length > 0)) ||
                          txnPayLoad?.amount.length > 0 ||
                          txnPayLoad?.ownerAccountId ||
                          (startDate && endDate) ||
                          isPaymentMethod?.length > 0 ||
                          txnAmountFilter?.length > 0 ||
                          selectedOwnerAccId?.length > 0 ||
                          (startDateFilter && endDateFilter))
                        ? "1"
                        : "0.6"
                      : txnHistorytype === "ownerDetailTxnHistory" &&
                        balanceType == "debit"
                      ? txnHistorytype === "ownerDetailTxnHistory" &&
                        accountNumber &&
                        selectedOwnerAccId?.length > 0 &&
                        (paymentMethod ||
                          (!isConfPopup &&
                            (confidentialMethod ||
                              isConfidentialMethod?.length > 0)) ||
                          txnPayLoad?.amount.length > 0 ||
                          txnPayLoad?.beneAccountId ||
                          (startDate && endDate) ||
                          isPaymentMethod?.length > 0 ||
                          txnAmountFilter?.length > 0 ||
                          (startDateFilter && endDateFilter))
                        ? "1"
                        : "0.6"
                      : paymentMethod ||
                        (!isConfPopup &&
                          (confidentialMethod ||
                            isConfidentialMethod?.length > 0)) ||
                        txnPayLoad?.amount.length > 0 ||
                        txnPayLoad?.ownerAccountId ||
                        (startDate && endDate) ||
                        isPaymentMethod?.length > 0 ||
                        txnAmountFilter?.length > 0 ||
                        selectedOwnerAccId?.length > 0 ||
                        (startDateFilter && endDateFilter)
                      ? "1"
                      : "0.6",
                  borderRadius: "40px",
                }}
              >
                Clear
              </div>
              <div
                className="acc-viewall-apply-filter text-center text-Primary_white text-xs w-1/2 py-[10px]"
                onClick={() => {
                  if (txnHistorytype === "internalTxnHistory") {
                    if (
                      txnHistorytype === "internalTxnHistory" &&
                      accountNumber &&
                      selectedOwnerAccId?.length > 0 &&
                      (paymentMethod ||
                        (!isConfPopup &&
                          (confidentialMethod ||
                            isConfidentialMethod?.length > 0)) ||
                        txnPayLoad?.amount.length > 0 ||
                        // txnPayLoad?.ownerAccountId ||
                        isPaymentMethod?.length > 0 ||
                        txnAmountFilter?.length > 0 ||
                        (startDate && endDate && isDateConfirmed))
                    ) {
                      filterCategory();
                    }
                  } else if (
                    txnHistorytype === "ownerDetailTxnHistory" &&
                    balanceType === "credit"
                  ) {
                    if (
                      txnHistorytype === "ownerDetailTxnHistory" &&
                      balanceType === "credit" &&
                      accountNumber &&
                      selectedBeneAccId?.length > 0 &&
                      (paymentMethod ||
                        (!isConfPopup &&
                          (confidentialMethod ||
                            isConfidentialMethod?.length > 0)) ||
                        txnPayLoad?.amount.length > 0 ||
                        selectedOwnerAccId?.length > 0 ||
                        txnPayLoad?.ownerAccountId ||
                        isPaymentMethod?.length > 0 ||
                        txnAmountFilter?.length > 0 ||
                        (startDate && endDate && isDateConfirmed))
                    ) {
                      filterCategory();
                    }
                  } else if (
                    txnHistorytype === "ownerDetailTxnHistory" &&
                    balanceType === "debit"
                  ) {
                    if (
                      txnHistorytype === "ownerDetailTxnHistory" &&
                      balanceType === "debit" &&
                      accountNumber &&
                      selectedOwnerAccId?.length > 0 &&
                      (paymentMethod ||
                        (!isConfPopup &&
                          (confidentialMethod ||
                            isConfidentialMethod?.length > 0)) ||
                        txnPayLoad?.amount.length > 0 ||
                        txnPayLoad?.beneAccountId ||
                        isPaymentMethod?.length > 0 ||
                        txnAmountFilter?.length > 0 ||
                        (startDate && endDate && isDateConfirmed))
                    ) {
                      filterCategory();
                    }
                  } else if (handleFilterApply()) {
                    filterCategory();
                  }
                  // if (
                  // paymentMethod ||
                  // txnPayLoad?.amount.length > 0 ||
                  // txnAmountFilter.length > 0 ||
                  // txnPayLoad?.ownerAccountId ||
                  // ((startDate || endDate) && isDateConfirmed) ||
                  // isPaymentMethod?.length > 0 ||
                  // txnAmountFilter?.length > 0 ||
                  // selectedOwnerAccId?.length > 0 ||
                  // (startDateFilter && endDateFilter)
                  //   handleFilterApply()
                  // ) {
                  //   filterCategory();
                  // }
                }}
                style={{
                  borderRadius: "40px",
                  backgroundColor:
                    // paymentMethod ||
                    // txnPayLoad?.amount.length > 0 ||
                    // txnPayLoad?.ownerAccountId ||
                    // (startDate && endDate)
                    txnHistorytype === "internalTxnHistory"
                      ? txnHistorytype === "internalTxnHistory" &&
                        accountNumber &&
                        selectedOwnerAccId?.length > 0 &&
                        (paymentMethod ||
                          (!isConfPopup &&
                            ((confidentialMethod ?? true) ||
                              isConfidentialMethod?.length > 0)) ||
                          txnPayLoad?.amount.length > 0 ||
                          // txnPayLoad?.ownerAccountId ||
                          isPaymentMethod?.length > 0 ||
                          txnAmountFilter?.length > 0 ||
                          (startDate && endDate && isDateConfirmed))
                        ? "var(--Button_red)"
                        : "#727272"
                      : txnHistorytype === "ownerDetailTxnHistory" &&
                        balanceType == "credit"
                      ? txnHistorytype === "ownerDetailTxnHistory" &&
                        accountNumber &&
                        selectedBeneAccId?.length > 0 &&
                        (paymentMethod ||
                          (!isConfPopup &&
                            (confidentialMethod ||
                              isConfidentialMethod?.length > 0)) ||
                          txnPayLoad?.amount.length > 0 ||
                          txnPayLoad?.ownerAccountId ||
                          isPaymentMethod?.length > 0 ||
                          txnAmountFilter?.length > 0 ||
                          selectedOwnerAccId?.length > 0 ||
                          (startDate && endDate && isDateConfirmed))
                        ? "var(--Button_red)"
                        : "#727272"
                      : txnHistorytype === "ownerDetailTxnHistory" &&
                        balanceType == "debit"
                      ? txnHistorytype === "ownerDetailTxnHistory" &&
                        accountNumber &&
                        selectedOwnerAccId?.length > 0 &&
                        (paymentMethod ||
                          (!isConfPopup &&
                            (confidentialMethod ||
                              isConfidentialMethod?.length > 0)) ||
                          txnPayLoad?.amount.length > 0 ||
                          txnPayLoad?.beneAccountId ||
                          isPaymentMethod?.length > 0 ||
                          txnAmountFilter?.length > 0 ||
                          (startDate && endDate && isDateConfirmed))
                        ? "var(--Button_red)"
                        : "#727272"
                      : handleFilterApply()
                      ? "var(--Button_red)"
                      : "#727272",
                  cursor:
                    // paymentMethod ||
                    // txnPayLoad?.amount.length > 0 ||
                    // txnPayLoad?.ownerAccountId ||
                    // (startDate && endDate)
                    txnHistorytype === "internalTxnHistory"
                      ? txnHistorytype === "internalTxnHistory" &&
                        accountNumber &&
                        selectedOwnerAccId?.length > 0 &&
                        (paymentMethod ||
                          (!isConfPopup &&
                            (confidentialMethod ||
                              isConfidentialMethod?.length > 0)) ||
                          txnPayLoad?.amount.length > 0 ||
                          // txnPayLoad?.ownerAccountId ||
                          isPaymentMethod?.length > 0 ||
                          txnAmountFilter?.length > 0 ||
                          (startDate && endDate && isDateConfirmed))
                        ? "pointer"
                        : "default"
                      : txnHistorytype === "ownerDetailTxnHistory" &&
                        balanceType == "credit"
                      ? txnHistorytype === "ownerDetailTxnHistory" &&
                        accountNumber &&
                        selectedBeneAccId?.length > 0 &&
                        (paymentMethod ||
                          (!isConfPopup &&
                            (confidentialMethod ||
                              isConfidentialMethod?.length > 0)) ||
                          txnPayLoad?.amount.length > 0 ||
                          txnPayLoad?.ownerAccountId ||
                          isPaymentMethod?.length > 0 ||
                          txnAmountFilter?.length > 0 ||
                          selectedOwnerAccId?.length > 0 ||
                          (startDate && endDate && isDateConfirmed))
                        ? "pointer"
                        : "default"
                      : txnHistorytype === "ownerDetailTxnHistory" &&
                        balanceType == "debit"
                      ? txnHistorytype === "ownerDetailTxnHistory" &&
                        accountNumber &&
                        selectedOwnerAccId?.length > 0 &&
                        (paymentMethod ||
                          (!isConfPopup &&
                            (confidentialMethod ||
                              isConfidentialMethod?.length > 0)) ||
                          txnPayLoad?.amount.length > 0 ||
                          txnPayLoad?.beneAccountId ||
                          isPaymentMethod?.length > 0 ||
                          txnAmountFilter?.length > 0 ||
                          (startDate && endDate && isDateConfirmed))
                        ? "pointer"
                        : "default"
                      : handleFilterApply()
                      ? "pointer"
                      : "default",
                }}
              >
                Apply
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div
            // onClose={toggleSidebar(false)}
            className={`internalTxnviewallsidebar ${
              isOpen ? "open" : "closed"
            }`}
            style={{
              backgroundColor: "var(--Blue_3)",
              pointerEvents: isViewModalOpen ? "none" : "",
              position:
                txnHistorytype === "internalTxnHistory" ||
                txnHistorytype === "ownerDetailTxnHistory"
                  ? "absolute"
                  : "fixed",
              marginTop:
                txnHistorytype === "internalTxnHistory" ||
                txnHistorytype === "ownerDetailTxnHistory"
                  ? "60px"
                  : "175px",
            }}
          >
            <div
              className="internalTxnviewallFilterDiv"
              style={{
                visibility: isOpen ? "visible" : "hidden",
                transition: `opacity 0.2s ease-in ${isOpen ? "0s" : "0.2s"}`,
                opacity: isOpen ? "1" : "0",
                borderTop: "2px solid rgb(29, 58, 109)",
              }}
            >
              <span className="text-Failed font-semibold text-[14px]">
                Filter
              </span>
              <div
                className="mt-1"
                style={{ display: "flex", position: "relative" }}
              >
                <div className="internalTxnFilterSection1">
                  {!isDropdownOpen && (
                    <div className="relative w-[216px]">
                      <span
                        style={{
                          color: "var(--Primary_grey)",
                          font: "normal normal 12px/19px Open Sans",
                        }}
                      >
                        Payment method
                      </span>

                      <div
                        className="internalTxn_payment_select mt-[10px]"
                        ref={paymentDropdownRef}
                        onClick={(e) => {
                          setDropdownPaymentOpen(!isDropdownPaymentOpen);
                          setIsDropdownOpen(false);
                          setShowDatePicker(false);
                          e.stopPropagation();
                        }}
                        style={{
                          height: isDropdownPaymentOpen ? "125px" : "35px",
                          outline: isDropdownPaymentOpen
                            ? "1px solid var(--Failed)"
                            : "",
                          transition: isDropdownPaymentOpen ? "none" : "",
                          opacity:
                            currentStatus === "require approval" ? "0.5" : "1",
                          position: "absolute",
                          zIndex: "9999",
                        }}
                        disabled={
                          currentStatus === "require approval" ? true : false
                        }
                      >
                        <div className="bene_txn_category_select_select">
                          <div
                            className="paymentTxn_category_select_scroll_line"
                            style={{
                              display: isDropdownPaymentOpen ? "block" : "none",
                            }}
                          ></div>

                          <span
                            style={{
                              fontSize: "12px",
                              paddingLeft: isDropdownPaymentOpen && "9px",
                              color: paymentMethod
                                ? "var(--Primary_white)"
                                : "var(--Primary_grey)",
                            }}
                          >
                            {paymentMethod === ""
                              ? "Select type"
                              : paymentMethod}
                          </span>
                          <div className="flex flex-row items-center">
                            <img
                              src={clear_filter}
                              alt="clear"
                              className="w-[9px] h-[9px]"
                              style={{
                                visibility:
                                  paymentMethod === "" || !isOpen
                                    ? "hidden"
                                    : "visible",
                              }}
                              onClick={(e) => {
                                setPaymentMethod("");
                                e.stopPropagation();
                              }}
                            />
                            <div
                              className="w-[1px] h-[16px] mx-[8px]"
                              style={{
                                backgroundColor: "var(--Blue_3)",
                                visibility:
                                  paymentMethod === "" || !isOpen
                                    ? "hidden"
                                    : "visible",
                              }}
                            ></div>
                            <img
                              src={arrowDown}
                              alt="down"
                              className="w-[11px] h-[11px]"
                              style={{
                                transform: isDropdownPaymentOpen
                                  ? "rotate(180deg)"
                                  : "rotate(0deg)",
                              }}
                            />
                          </div>
                        </div>

                        {isDropdownPaymentOpen && (
                          <div className="bg-Blue_8 absolute top-12 flex flex-col items-start rounded-[10px] w-full h-[82px]">
                            {["NEFT", "RTGS"].map((settlement) => (
                              <div
                                key={settlement}
                                className="flex w-[208px] h-[35px] hover:bg-Blue_7 cursor-pointer rounded-[5px] border-l-transparent ml-1"
                                style={{
                                  backgroundColor:
                                    paymentMethod === settlement &&
                                    paymentMethod
                                      ? "var(--Blue_6)"
                                      : "",
                                  padding: "0px 8px",
                                }}
                                onClick={(e) => {
                                  handleSettlementClick(settlement);
                                  setIsDropdownOpen(false);
                                }}
                              >
                                <span className="py-2.5 text-Primary_grey text-xs truncate w-[170px] ">
                                  {settlement}
                                </span>
                                <div
                                  style={{
                                    display:
                                      paymentMethod == settlement
                                        ? "flex"
                                        : "none",
                                    textAlign: "right",
                                    justifyContent: "end",
                                    paddingRight: "1px",
                                    marginTop: "10px",
                                  }}
                                >
                                  <img
                                    style={{
                                      height: "13px",
                                      width: "14px",
                                    }}
                                    src={allChecker}
                                    alt="check"
                                  />
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {hasConfidential && !isDropdownOpen && (
                    <div className="relative w-[216px]  mt-[60px]">
                      <span
                        style={{
                          color: "var(--Primary_grey)",
                          font: "normal normal 12px/19px Open Sans",
                        }}
                      >
                        Show/hide confidential transactions
                      </span>

                      <div
                        className="internalTxn_payment_select mt-[10px]"
                        ref={confidentialDropdownRef}
                        onClick={(e) => {
                          setIsDropdownConfidentialOpen(
                            !isDropdownConfidentialOpen
                          );
                          setDropdownOpen(false);
                          setShowDatePicker(false);
                          e.stopPropagation();
                        }}
                        style={{
                          height: isDropdownConfidentialOpen ? "125px" : "35px",
                          outline: isDropdownConfidentialOpen
                            ? "1px solid var(--Failed)"
                            : "",
                          transition: isDropdownConfidentialOpen ? "none" : "",
                          opacity:
                            currentStatus === "require approval" ||
                            (txnHistorytype === "internalTxnHistory" &&
                              detailConfidential === "Y")
                              ? "0.5"
                              : "1",
                        }}
                        disabled={
                          currentStatus === "require approval" ||
                          (txnHistorytype === "internalTxnHistory" &&
                            detailConfidential === "Y")
                            ? true
                            : false
                        }
                      >
                        <div className="bene_txn_category_select_select">
                          <div
                            className="txn_category_select_scroll_line"
                            style={{
                              display: isDropdownConfidentialOpen
                                ? "block"
                                : "none",
                            }}
                          ></div>

                          <span
                            style={{
                              fontSize: "12px",
                              paddingLeft: isDropdownConfidentialOpen && "9px",
                              color: confidentialMethod
                                ? "var(--Primary_white)"
                                : "var(--Primary_grey)",
                            }}
                          >
                            {confidentialMethod === ""
                              ? "Default (all transactions)"
                              : confidentialMethod}
                          </span>
                          <div className="flex flex-row items-center">
                            <img
                              src={clear_filter}
                              alt="clear"
                              className="w-[9px] h-[9px]"
                              style={{
                                visibility:
                                  confidentialMethod === "" || !isOpen
                                    ? "hidden"
                                    : "visible",
                              }}
                              onClick={(e) => {
                                setConfidentialMethod("");
                                e.stopPropagation();
                              }}
                            />
                            <div
                              className="w-[1px] h-[16px] mx-[8px]"
                              style={{
                                backgroundColor: "var(--Blue_3)",
                                visibility:
                                  confidentialMethod === "" || !isOpen
                                    ? "hidden"
                                    : "visible",
                              }}
                            ></div>
                            <img
                              src={arrowDown}
                              alt="down"
                              className="w-[11px] h-[11px]"
                              style={{
                                transform: isDropdownConfidentialOpen
                                  ? "rotate(180deg)"
                                  : "rotate(0deg)",
                              }}
                            />
                          </div>
                        </div>

                        {isDropdownConfidentialOpen && (
                          <div className="bg-Blue_8 absolute top-12 flex flex-col items-start rounded-[10px] w-full h-[82px]">
                            {filterConfidential.map((confidential) => (
                              <div
                                key={confidential}
                                className="flex w-[208px] h-[35px] hover:bg-Blue_7 cursor-pointer rounded-[5px] border-l-transparent ml-1"
                                style={{
                                  backgroundColor:
                                    confidentialMethod === confidential &&
                                    confidentialMethod
                                      ? "var(--Blue_6)"
                                      : "",
                                  padding: "0px 8px",
                                }}
                                onClick={() => {
                                  handleConfidentialClick(confidential);
                                  SetDashBoardisConfidentialFilter(
                                    confidential
                                  );
                                  setIsDropdownConfidentialOpen(false);
                                }}
                              >
                                <span className="py-2.5 text-Primary_grey text-xs truncate w-[170px] ">
                                  {confidential}
                                </span>
                                <div
                                  style={{
                                    display:
                                      confidentialMethod == confidential
                                        ? "flex"
                                        : "none",
                                    textAlign: "right",
                                    justifyContent: "end",
                                    paddingRight: "1px",
                                    marginTop: "10px",
                                  }}
                                >
                                  <img
                                    style={{
                                      height: "13px",
                                      width: "14px",
                                    }}
                                    src={allChecker}
                                    alt="check"
                                  />
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                <div className="internalTxnFilterSection2 pl-[27px]">
                  <div className="relative w-[216px]">
                    <span
                      style={{
                        color: "var(--Primary_grey)",
                        font: "normal normal 12px/19px Open Sans",
                      }}
                    >
                      Destination account
                    </span>
                    <div
                      ref={viewModalRef}
                      className="relative flex flex-col items-center rounded-[10px] h-[35px] pl-[12px] pr-[7px] py-2.5 bg-Blue_8 w-[216px] mt-[4px]"
                      style={{
                        opacity:
                          txnHistorytype === "ownerDetailTxnHistory" &&
                          balanceType === "credit"
                            ? "0.5"
                            : currentStatus === "require approval"
                            ? "0.5"
                            : "0.5",
                        cursor:
                          txnHistorytype === "ownerDetailTxnHistory" &&
                          balanceType === "credit"
                            ? "default"
                            : currentStatus === "require approval"
                            ? "default"
                            : "default",
                      }}
                    >
                      <button
                        className="flex items-center justify-between border-transparent active:border-white w-full mt-[-1px]"
                        // onClick={handleOpenViewModalOwner}
                        onClick={() => {
                          if (
                            txnHistorytype === "ownerDetailTxnHistory" &&
                            balanceType === "credit"
                          ) {
                            return;
                          } else {
                            toast.info("Coming Soon...", toast_position);
                          }
                        }}
                        disabled={
                          currentStatus === "require approval" ? true : false
                        }
                        style={{
                          cursor:
                            txnHistorytype === "ownerDetailTxnHistory" &&
                            balanceType === "credit"
                              ? "default"
                              : currentStatus === "require approval"
                              ? "default"
                              : "default",
                        }}
                      >
                        <span
                          className="internalTxn_filter_acc_selected text-xs truncate"
                          style={{
                            color: txnPayLoad?.ownerbankAccountNo
                              ? "var(--Primary_white)"
                              : "var(--Primary_grey)",
                          }}
                        >
                          {txnHistorytype === "ownerDetailTxnHistory" &&
                          balanceType === "credit" &&
                          accountNumber
                            ? formatAccountNumber(accountNumber)
                            : "Select owner account"}
                          {/* {txnPayLoad?.ownerbankAccountNo === ""
                      ? "Select owner account"
                      : txnPayLoad?.ownerbankAccountNo} */}
                        </span>
                        <img
                          className="internalTxn_viewall_select_account h-[11px] w-[11px]"
                          src={arrowDown}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                  <div className="relative w-[216px] mt-[20px]">
                    <span
                      style={{
                        color: "var(--Primary_grey)",
                        font: "normal normal 12px/19px Open Sans",
                      }}
                    >
                      Source account
                    </span>
                    <div
                      className="relative flex flex-col items-center rounded-[10px] h-[35px] pl-[12px] pr-[7px] py-2.5 bg-Blue_8 w-[216px] mt-[4px]"
                      style={{
                        opacity:
                          txnHistorytype !== "internalTxnHistory" &&
                          txnHistorytype !== "ownerDetailTxnHistory"
                            ? "1"
                            : txnHistorytype === "ownerDetailTxnHistory" &&
                              balanceType === "credit"
                            ? "1"
                            : currentStatus === "require approval"
                            ? "0.5"
                            : "0.5",
                      }}
                    >
                      <button
                        className="flex items-center justify-between border-transparent active:border-white w-full mt-[-1px]"
                        onClick={(e) => {
                          if (
                            txnHistorytype !== "internalTxnHistory" &&
                            txnHistorytype !== "ownerDetailTxnHistory"
                          ) {
                            handleOpenViewModalOwner();
                            e.stopPropagation();
                          } else if (
                            txnHistorytype === "ownerDetailTxnHistory" &&
                            balanceType === "credit"
                          ) {
                            handleOpenViewModalOwner();
                            e.stopPropagation();
                          }
                        }}
                        disabled={
                          txnHistorytype === "internalTxnHistory" ||
                          (txnHistorytype === "ownerDetailTxnHistory" &&
                            balanceType === "debit")
                            ? true
                            : false
                        }
                        style={{
                          cursor:
                            txnHistorytype === "internalTxnHistory" ||
                            (txnHistorytype === "ownerDetailTxnHistory" &&
                              balanceType === "debit")
                              ? "default"
                              : "pointer",
                        }}
                      >
                        <span
                          className="internalTxn_filter_acc_selected text-xs truncate"
                          style={{
                            color: txnPayLoad?.ownerbankAccountNo
                              ? "var(--Primary_white)"
                              : "var(--Primary_grey)",
                          }}
                        >
                          {txnHistorytype === "internalTxnHistory" &&
                          accountNumber
                            ? formatAccountNumber(accountNumber)
                            : txnHistorytype === "ownerDetailTxnHistory" &&
                              balanceType === "debit" &&
                              accountNumber
                            ? formatAccountNumber(accountNumber)
                            : txnPayLoad?.ownerbankAccountNo === ""
                            ? "Select owner account"
                            : formatAccountNumber(
                                txnPayLoad?.ownerbankAccountNo
                              )}
                        </span>
                        <div className="flex flex-row items-center">
                          <img
                            src={clear_filter}
                            alt="clear"
                            className="w-[9px] h-[9px]"
                            style={{
                              visibility:
                                (txnPayLoad?.ownerbankAccountNo === "" &&
                                  txnPayLoad?.ownerAccountId === "") ||
                                !isOpen
                                  ? "hidden"
                                  : "visible",
                            }}
                            onClick={(e) => {
                              setTxnPayLoad({
                                ...txnPayLoad,
                                ownerbankAccountNo: "",
                                ownerAccountId: "",
                              });
                              e.stopPropagation();
                            }}
                          />
                          <div
                            className="w-[1px] h-[16px] mx-[8px]"
                            style={{
                              backgroundColor: "var(--Blue_3)",
                              visibility:
                                (txnPayLoad?.ownerbankAccountNo === "" &&
                                  txnPayLoad?.ownerAccountId === "") ||
                                !isOpen
                                  ? "hidden"
                                  : "visible",
                            }}
                          ></div>
                          <img
                            className="txn_viewall_select_account h-[11px] w-[11px]"
                            src={arrowDown}
                            alt=""
                          />
                        </div>
                      </button>
                    </div>
                  </div>

                  {/* <div className="relative w-[200px] mt-5">
              <span
                style={{
                  width: "35px",
                  height: "19px",
                  font: "normal normal 12px/19px Open Sans",
                }}
              >
                IFSC code
              </span>
              <input
                className="w-[216px] h-[35px] px-4 py-2.5 rounded-[10px] bg-Blue_8 text-Primary_white placeholder-Primary_grey text-xs mt-[5px]"
                maxlength="11"
                type="text"
                name="ifscnumber"
                placeholder="Enter IFSC code"
                value=""
                // onChange={(e) => handleTxnSearch(e.target.value)}
              />
            </div>
            <div>
              <p class="internalTxn_number_text">
                Note : Account number and IFSC code <br />
                must be filled to filter by bank details
              </p>
            </div> */}
                </div>

                <div className="internalTxnFilterSection3 pl-[27px]">
                  <div>
                    <span
                      style={{
                        color: "var(--Primary_grey)",
                        font: "normal normal 12px/19px Open Sans",
                        marginBottom: "5px",
                      }}
                    >
                      Date range
                    </span>
                    <div
                      className="internalTxn_Calendar_main_div absolute flex flex-col items-center bg-Blue_8 z-[9] mt-[4px]"
                      // style={{ opacity: dropdownOpen ? 0 : 1 }}
                      ref={dateRef}
                      style={{
                        width: "305px",
                        height: showDatePicker ? "" : "35px",
                        border: showDatePicker
                          ? "1px solid var(--Failed)"
                          : "none",
                        // borderRadius: showDatePicker ? "10px" : "auto",
                      }}
                    >
                      <div
                        className="flex flex-row items-center justify-between rounded-[10px] bg-Blue_8"
                        style={{
                          width: "305px",
                          height: showDatePicker ? "" : "35px",
                          // border: showDatePicker ? "none" : "1px solid var(--Failed)",
                          opacity:
                            currentStatus === "require approval" ? "0.5" : "1",
                          cursor:
                            currentStatus === "require approval"
                              ? "default"
                              : "pointer",
                        }}
                        onClick={(e) => {
                          setShowDatePicker(!showDatePicker);
                          setDropdownOpen(false);
                          setIsDropdownOpen(false);
                          setActiveSection("date");
                        }}
                        disabled={
                          currentStatus === "require approval" ? true : false
                        }
                        // style={{ opacity: dropdownOpen ? 0 : 1 }}
                      >
                        <div
                          className="internalTxn_date_heading_div cursor-pointer"
                          style={{
                            borderTopLeftRadius: showDatePicker
                              ? "7px"
                              : "none",
                            borderLeft: showDatePicker
                              ? "1px solid var(--Failed)"
                              : "none",
                          }}
                          // onClick={() => setShowDatePicker((prev) => !prev)}
                        >
                          <div
                            className="internalTxn_date_heading_left"
                            style={{
                              color: startDate
                                ? "var(--Primary_white)"
                                : "var(--Primary_grey)",
                            }}
                          >
                            {startDate
                              ? formatDate(startDate)
                              : "Select from date"}
                          </div>
                        </div>
                        <img
                          src={arrowforward}
                          className="internalTxn_viewall_calendar_icon"
                        />
                        <div
                          className="internalTxn_date_select_div cursor-pointer"
                          style={{
                            borderTopRightRadius: showDatePicker
                              ? "7px"
                              : "none",
                            borderRight: showDatePicker
                              ? "1px solid var(--Failed)"
                              : "none",
                          }}
                          // onClick={() => setShowDatePicker((prev) => !prev)}
                        >
                          <div
                            className="internalTxn_date_heading_right"
                            style={{
                              color: endDate
                                ? "var(--Primary_white)"
                                : "var(--Primary_grey)",
                            }}
                          >
                            {endDate ? formatDate(endDate) : "Select to date"}
                          </div>
                        </div>
                      </div>
                      {showDatePicker && (
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                        >
                          <DatePickerComponent
                            startDate={startDate}
                            endDate={endDate}
                            handleDateChange={handleDateChange}
                            handleCancel={handleCancel}
                            handleConfirm={handleConfirm}
                            showDatePicker={showDatePicker}
                            yearDropdownRef={yearDropdownRef}
                            dateRef={dateRef}
                            setShowDatePicker={setShowDatePicker}
                            isOpen={isOpen}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div
                    className="relative w-[200px] mt-[3.4rem]"
                    style={{
                      visibility: showDatePicker ? "hidden" : "",
                    }}
                  >
                    <span
                      style={{
                        color: "var(--Primary_grey)",
                        font: "normal normal 12px/19px Open Sans",
                      }}
                    >
                      Amount
                    </span>

                    <div
                      className="w-[305px] h-[35px] px-4 py-2.5 rounded-[10px] bg-Blue_8 text-Primary_white placeholder-Primary_grey text-xs mt-[4px]"
                      style={{
                        opacity:
                          currentStatus === "require approval" ? "0.3" : "1",
                        outline: "none",
                      }}
                    >
                      &#8377;
                      <input
                        className="ml-[3px] bg-Blue_8 text-Primary_white placeholder-Primary_grey w-[250px]"
                        type="text"
                        placeholder="Enter transaction amount"
                        value={
                          txnPayLoad?.amount.length > 0
                            ? txnPayLoad?.amount
                            : ""
                        }
                        name="txnamount"
                        onChange={(e) => handleTxnSearch(e.target.value)}
                        onFocus={() => setActiveSection("txnamount")}
                        disabled={
                          currentStatus === "require approval" ? true : false
                        }
                      />
                    </div>
                  </div>
                </div>

                <div className="internalTxnFilterbuttonContainer">
                  <div
                    className="acc-viewall-clear-filter border border-Primary_white text-Primary_white text-xs text-center hover:opacity-80 w-[87px] h-[25px]"
                    onClick={() => {
                      if (
                        txnHistorytype === "internalTxnHistory" &&
                        accountNumber &&
                        selectedOwnerAccId?.length > 0 &&
                        (paymentMethod ||
                          (!isConfPopup &&
                            (confidentialMethod ||
                              isConfidentialMethod?.length > 0)) ||
                          startDate ||
                          endDate ||
                          txnPayLoad?.amount.length > 0 ||
                          // txnPayLoad?.ownerAccountId ||
                          isPaymentMethod?.length > 0 ||
                          txnAmountFilter?.length > 0 ||
                          (startDateFilter && endDateFilter))
                      ) {
                        clearFilter();
                      } else if (
                        txnHistorytype === "ownerDetailTxnHistory" &&
                        balanceType === "credit"
                      ) {
                        if (
                          txnHistorytype === "ownerDetailTxnHistory" &&
                          balanceType === "credit" &&
                          accountNumber &&
                          selectedBeneAccId?.length > 0 &&
                          (paymentMethod ||
                            (!isConfPopup &&
                              (confidentialMethod ||
                                isConfidentialMethod?.length > 0)) ||
                            txnPayLoad?.amount.length > 0 ||
                            selectedOwnerAccId?.length > 0 ||
                            txnPayLoad?.ownerAccountId ||
                            (startDate && endDate) ||
                            isPaymentMethod?.length > 0 ||
                            txnAmountFilter?.length > 0 ||
                            (startDateFilter && endDateFilter))
                        ) {
                          clearFilter();
                        }
                      } else if (
                        txnHistorytype === "ownerDetailTxnHistory" &&
                        balanceType === "debit"
                      ) {
                        if (
                          txnHistorytype === "ownerDetailTxnHistory" &&
                          balanceType === "debit" &&
                          accountNumber &&
                          selectedOwnerAccId?.length > 0 &&
                          (paymentMethod ||
                            (!isConfPopup &&
                              (confidentialMethod ||
                                isConfidentialMethod?.length > 0)) ||
                            txnPayLoad?.amount.length > 0 ||
                            txnPayLoad?.beneAccountId ||
                            (startDate && endDate) ||
                            isPaymentMethod?.length > 0 ||
                            txnAmountFilter?.length > 0 ||
                            (startDateFilter && endDateFilter))
                        ) {
                          clearFilter();
                        }
                      } else if (
                        (txnHistorytype !== "internalTxnHistory" &&
                          !accountNumber &&
                          paymentMethod) ||
                        startDate ||
                        endDate ||
                        (!isConfPopup &&
                          (confidentialMethod ||
                            isConfidentialMethod?.length > 0)) ||
                        txnPayLoad?.amount.length > 0 ||
                        txnPayLoad?.ownerAccountId ||
                        isPaymentMethod?.length > 0 ||
                        txnAmountFilter?.length > 0 ||
                        selectedOwnerAccId?.length > 0 ||
                        (startDateFilter && endDateFilter)
                      ) {
                        clearFilter();
                      }
                    }}
                    style={{
                      cursor:
                        txnHistorytype === "internalTxnHistory"
                          ? txnHistorytype === "internalTxnHistory" &&
                            accountNumber &&
                            selectedOwnerAccId?.length > 0 &&
                            (paymentMethod ||
                              (!isConfPopup &&
                                (confidentialMethod ||
                                  isConfidentialMethod?.length > 0)) ||
                              txnPayLoad?.amount.length > 0 ||
                              // txnPayLoad?.ownerAccountId ||
                              (startDate && endDate) ||
                              isPaymentMethod?.length > 0 ||
                              txnAmountFilter?.length > 0 ||
                              (startDateFilter && endDateFilter))
                            ? "pointer"
                            : "default"
                          : txnHistorytype === "ownerDetailTxnHistory" &&
                            balanceType == "credit"
                          ? txnHistorytype === "ownerDetailTxnHistory" &&
                            accountNumber &&
                            selectedBeneAccId?.length > 0 &&
                            (paymentMethod ||
                              (!isConfPopup &&
                                (confidentialMethod ||
                                  isConfidentialMethod?.length > 0)) ||
                              txnPayLoad?.amount.length > 0 ||
                              txnPayLoad?.ownerAccountId ||
                              (startDate && endDate) ||
                              isPaymentMethod?.length > 0 ||
                              txnAmountFilter?.length > 0 ||
                              selectedOwnerAccId?.length > 0 ||
                              (startDateFilter && endDateFilter))
                            ? "pointer"
                            : "default"
                          : txnHistorytype === "ownerDetailTxnHistory" &&
                            balanceType == "debit"
                          ? txnHistorytype === "ownerDetailTxnHistory" &&
                            accountNumber &&
                            selectedOwnerAccId?.length > 0 &&
                            (paymentMethod ||
                              (!isConfPopup &&
                                (confidentialMethod ||
                                  isConfidentialMethod?.length > 0)) ||
                              txnPayLoad?.amount.length > 0 ||
                              txnPayLoad?.beneAccountId ||
                              (startDate && endDate) ||
                              isPaymentMethod?.length > 0 ||
                              txnAmountFilter?.length > 0 ||
                              (startDateFilter && endDateFilter))
                            ? "pointer"
                            : "default"
                          : paymentMethod ||
                            (!isConfPopup &&
                              (confidentialMethod ||
                                isConfidentialMethod?.length > 0)) ||
                            txnPayLoad?.amount.length > 0 ||
                            txnPayLoad?.ownerAccountId ||
                            (startDate && endDate) ||
                            isPaymentMethod?.length > 0 ||
                            txnAmountFilter?.length > 0 ||
                            selectedOwnerAccId?.length > 0 ||
                            (startDateFilter && endDateFilter)
                          ? "pointer"
                          : "default",
                      opacity:
                        txnHistorytype === "internalTxnHistory"
                          ? txnHistorytype === "internalTxnHistory" &&
                            accountNumber &&
                            selectedOwnerAccId?.length > 0 &&
                            (paymentMethod ||
                              (!isConfPopup &&
                                (confidentialMethod ||
                                  isConfidentialMethod?.length > 0)) ||
                              txnPayLoad?.amount.length > 0 ||
                              // txnPayLoad?.ownerAccountId ||
                              (startDate && endDate) ||
                              isPaymentMethod?.length > 0 ||
                              txnAmountFilter?.length > 0 ||
                              (startDateFilter && endDateFilter))
                            ? "1"
                            : "0.6"
                          : txnHistorytype === "ownerDetailTxnHistory" &&
                            balanceType == "credit"
                          ? txnHistorytype === "ownerDetailTxnHistory" &&
                            accountNumber &&
                            selectedBeneAccId?.length > 0 &&
                            (paymentMethod ||
                              (!isConfPopup &&
                                (confidentialMethod ||
                                  isConfidentialMethod?.length > 0)) ||
                              txnPayLoad?.amount.length > 0 ||
                              txnPayLoad?.ownerAccountId ||
                              (startDate && endDate) ||
                              isPaymentMethod?.length > 0 ||
                              txnAmountFilter?.length > 0 ||
                              selectedOwnerAccId?.length > 0 ||
                              (startDateFilter && endDateFilter))
                            ? "1"
                            : "0.6"
                          : txnHistorytype === "ownerDetailTxnHistory" &&
                            balanceType == "debit"
                          ? txnHistorytype === "ownerDetailTxnHistory" &&
                            accountNumber &&
                            selectedOwnerAccId?.length > 0 &&
                            (paymentMethod ||
                              (!isConfPopup &&
                                (confidentialMethod ||
                                  isConfidentialMethod?.length > 0)) ||
                              txnPayLoad?.amount.length > 0 ||
                              txnPayLoad?.beneAccountId ||
                              (startDate && endDate) ||
                              isPaymentMethod?.length > 0 ||
                              txnAmountFilter?.length > 0 ||
                              (startDateFilter && endDateFilter))
                            ? "1"
                            : "0.6"
                          : paymentMethod ||
                            (!isConfPopup &&
                              (confidentialMethod ||
                                isConfidentialMethod?.length > 0)) ||
                            txnPayLoad?.amount.length > 0 ||
                            txnPayLoad?.ownerAccountId ||
                            (startDate && endDate) ||
                            isPaymentMethod?.length > 0 ||
                            txnAmountFilter?.length > 0 ||
                            selectedOwnerAccId?.length > 0 ||
                            (startDateFilter && endDateFilter)
                          ? "1"
                          : "0.6",
                    }}
                  >
                    Clear
                  </div>
                  <div
                    ref={applyBtnRef}
                    className="acc-viewall-apply-filter text-center text-Primary_white text-xs ml-[10px] w-[87px] h-[25px]"
                    onClick={() => {
                      if (txnHistorytype === "internalTxnHistory") {
                        if (
                          txnHistorytype === "internalTxnHistory" &&
                          accountNumber &&
                          selectedOwnerAccId?.length > 0 &&
                          (paymentMethod ||
                            (!isConfPopup &&
                              (confidentialMethod ||
                                isConfidentialMethod?.length > 0)) ||
                            txnPayLoad?.amount.length > 0 ||
                            // txnPayLoad?.ownerAccountId ||
                            isPaymentMethod?.length > 0 ||
                            txnAmountFilter?.length > 0 ||
                            (startDate && endDate && isDateConfirmed))
                        ) {
                          filterCategory();
                        }
                      } else if (
                        txnHistorytype === "ownerDetailTxnHistory" &&
                        balanceType === "credit"
                      ) {
                        if (
                          txnHistorytype === "ownerDetailTxnHistory" &&
                          balanceType === "credit" &&
                          accountNumber &&
                          selectedBeneAccId?.length > 0 &&
                          (paymentMethod ||
                            (!isConfPopup &&
                              (confidentialMethod ||
                                isConfidentialMethod?.length > 0)) ||
                            txnPayLoad?.amount.length > 0 ||
                            selectedOwnerAccId?.length > 0 ||
                            txnPayLoad?.ownerAccountId ||
                            isPaymentMethod?.length > 0 ||
                            txnAmountFilter?.length > 0 ||
                            (startDate && endDate && isDateConfirmed))
                        ) {
                          filterCategory();
                        }
                      } else if (
                        txnHistorytype === "ownerDetailTxnHistory" &&
                        balanceType === "debit"
                      ) {
                        if (
                          txnHistorytype === "ownerDetailTxnHistory" &&
                          balanceType === "debit" &&
                          accountNumber &&
                          selectedOwnerAccId?.length > 0 &&
                          (paymentMethod ||
                            (!isConfPopup &&
                              (confidentialMethod ||
                                isConfidentialMethod?.length > 0)) ||
                            txnPayLoad?.amount.length > 0 ||
                            txnPayLoad?.beneAccountId ||
                            isPaymentMethod?.length > 0 ||
                            txnAmountFilter?.length > 0 ||
                            (startDate && endDate && isDateConfirmed))
                        ) {
                          filterCategory();
                        }
                      } else if (handleFilterApply()) {
                        filterCategory();
                      }
                      // if (
                      // paymentMethod ||
                      // txnPayLoad?.amount.length > 0 ||
                      // txnAmountFilter.length > 0 ||
                      // txnPayLoad?.ownerAccountId ||
                      // ((startDate || endDate) && isDateConfirmed) ||
                      // isPaymentMethod?.length > 0 ||
                      // txnAmountFilter?.length > 0 ||
                      // selectedOwnerAccId?.length > 0 ||
                      // (startDateFilter && endDateFilter)
                      //   handleFilterApply()
                      // ) {
                      //   filterCategory();
                      // }
                    }}
                    style={{
                      backgroundColor:
                        // paymentMethod ||
                        // txnPayLoad?.amount.length > 0 ||
                        // txnPayLoad?.ownerAccountId ||
                        // (startDate && endDate)
                        txnHistorytype === "internalTxnHistory"
                          ? txnHistorytype === "internalTxnHistory" &&
                            accountNumber &&
                            selectedOwnerAccId?.length > 0 &&
                            (paymentMethod ||
                              (!isConfPopup &&
                                ((confidentialMethod ?? true) ||
                                  isConfidentialMethod?.length > 0)) ||
                              txnPayLoad?.amount.length > 0 ||
                              // txnPayLoad?.ownerAccountId ||
                              isPaymentMethod?.length > 0 ||
                              txnAmountFilter?.length > 0 ||
                              (startDate && endDate && isDateConfirmed))
                            ? "var(--Button_red)"
                            : "var(--Secondary_grey)"
                          : txnHistorytype === "ownerDetailTxnHistory" &&
                            balanceType == "credit"
                          ? txnHistorytype === "ownerDetailTxnHistory" &&
                            accountNumber &&
                            selectedBeneAccId?.length > 0 &&
                            (paymentMethod ||
                              (!isConfPopup &&
                                (confidentialMethod ||
                                  isConfidentialMethod?.length > 0)) ||
                              txnPayLoad?.amount.length > 0 ||
                              txnPayLoad?.ownerAccountId ||
                              isPaymentMethod?.length > 0 ||
                              txnAmountFilter?.length > 0 ||
                              selectedOwnerAccId?.length > 0 ||
                              (startDate && endDate && isDateConfirmed))
                            ? "var(--Button_red)"
                            : "var(--Secondary_grey)"
                          : txnHistorytype === "ownerDetailTxnHistory" &&
                            balanceType == "debit"
                          ? txnHistorytype === "ownerDetailTxnHistory" &&
                            accountNumber &&
                            selectedOwnerAccId?.length > 0 &&
                            (paymentMethod ||
                              (!isConfPopup &&
                                (confidentialMethod ||
                                  isConfidentialMethod?.length > 0)) ||
                              txnPayLoad?.amount.length > 0 ||
                              txnPayLoad?.beneAccountId ||
                              isPaymentMethod?.length > 0 ||
                              txnAmountFilter?.length > 0 ||
                              (startDate && endDate && isDateConfirmed))
                            ? "var(--Button_red)"
                            : "var(--Secondary_grey)"
                          : handleFilterApply()
                          ? "var(--Button_red)"
                          : "var(--Secondary_grey)",
                      cursor:
                        // paymentMethod ||
                        // txnPayLoad?.amount.length > 0 ||
                        // txnPayLoad?.ownerAccountId ||
                        // (startDate && endDate)
                        txnHistorytype === "internalTxnHistory"
                          ? txnHistorytype === "internalTxnHistory" &&
                            accountNumber &&
                            selectedOwnerAccId?.length > 0 &&
                            (paymentMethod ||
                              (!isConfPopup &&
                                (confidentialMethod ||
                                  isConfidentialMethod?.length > 0)) ||
                              txnPayLoad?.amount.length > 0 ||
                              // txnPayLoad?.ownerAccountId ||
                              isPaymentMethod?.length > 0 ||
                              txnAmountFilter?.length > 0 ||
                              (startDate && endDate && isDateConfirmed))
                            ? "pointer"
                            : "default"
                          : txnHistorytype === "ownerDetailTxnHistory" &&
                            balanceType == "credit"
                          ? txnHistorytype === "ownerDetailTxnHistory" &&
                            accountNumber &&
                            selectedBeneAccId?.length > 0 &&
                            (paymentMethod ||
                              (!isConfPopup &&
                                (confidentialMethod ||
                                  isConfidentialMethod?.length > 0)) ||
                              txnPayLoad?.amount.length > 0 ||
                              txnPayLoad?.ownerAccountId ||
                              isPaymentMethod?.length > 0 ||
                              txnAmountFilter?.length > 0 ||
                              selectedOwnerAccId?.length > 0 ||
                              (startDate && endDate && isDateConfirmed))
                            ? "pointer"
                            : "default"
                          : txnHistorytype === "ownerDetailTxnHistory" &&
                            balanceType == "debit"
                          ? txnHistorytype === "ownerDetailTxnHistory" &&
                            accountNumber &&
                            selectedOwnerAccId?.length > 0 &&
                            (paymentMethod ||
                              (!isConfPopup &&
                                (confidentialMethod ||
                                  isConfidentialMethod?.length > 0)) ||
                              txnPayLoad?.amount.length > 0 ||
                              txnPayLoad?.beneAccountId ||
                              isPaymentMethod?.length > 0 ||
                              txnAmountFilter?.length > 0 ||
                              (startDate && endDate && isDateConfirmed))
                            ? "pointer"
                            : "default"
                          : handleFilterApply()
                          ? "pointer"
                          : "default",
                    }}
                  >
                    Apply
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default InternalTxnFilterSidebar;
